import React from "react";
import PageTitle from "../../components/PageTitle";
import { useNavigate } from "react-router-dom";
import ALevelMenu from "./ALevelMenu";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";

const Dashboard = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useQuery({
    queryKey: ["dashboardDataset"],
    queryFn: async () => {
      const req = await axiosget("ms_dashboard");
      return req?.data;
    },
  });
  return (
    <>
      <PageTitle />
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.type !== undefined && <ErrorResponse type={`danger`} message={`${data?.message}`} />}
      <div className="row">
        {data && !data?.type && (
          <div className="row">
            <div className="col-md-4 my-3 pointer" onClick={() => navigate("/app/parents")}>
              <div className={`card-counter ${data?.ref ? (data.ref >= 2 ? "success" : "info") : "danger"}`}>
                <i className="fa fa-hands-holding-child"></i>
                <span className="count-numbers">Parents</span>
                <span className="count-name">Guardians</span>
              </div>
            </div>

            <div className="col-md-4  my-3 pointer" onClick={() => navigate("/app/bio")}>
              <div className={`card-counter ${data?.bio ? "success" : "danger"}`}>
                <i className="fa fa-person-chalkboard"></i>
                <span className="count-numbers">Bio</span>
                <span className="count-name">Information</span>
              </div>
            </div>
            <ALevelMenu data={data} />
            <div className="col-md-4 pointer my-3" onClick={() => navigate("/app/alevel")}>
              <div className="card-counter secondary">
                <i className="fa fa-solid fa-square-poll-horizontal"></i>
                <span className="count-numbers">A-Level</span>
                <span className="count-name">Result Statement</span>
              </div>
            </div>

            <div className="col-md-4 pointer my-3" onClick={() => navigate("/app/photo")}>
              <div className={`card-counter ${data?.photo ? "success" : "danger"}`}>
                <i className="fa fa-image"></i>
                <span className="count-numbers">Upload </span>
                <span className="count-name">Passport Photograph</span>
              </div>
            </div>
            <div className="col-md-4 pointer my-3" onClick={() => navigate("/app/start")}>
              <div className="card-counter danger">
                <i className="fa fa-solid fa-list-ol"></i>
                <span className="count-numbers">Apply </span>
                <span className="count-name">For Admission</span>
              </div>
            </div>

            <div className="col-md-4 pointer my-3" onClick={() => navigate("/app/admission")}>
              <div className="card-counter info">
                <i className="fa fa-solid fa-clipboard"></i>
                <span className="count-numbers">My</span>
                <span className="count-name">Admission Letters</span>
              </div>
            </div>
            <div className="col-md-4 pointer my-3" onClick={() => navigate("/app/pay")}>
              <div className={`card-counter ${data?.pay ? "success" : "danger"}`}>
                <i className="fa fa-solid fa-naira-sign"></i>
                <span className="count-numbers">Pay </span>
                <span className="count-name">Before Application</span>
              </div>
            </div>
            <div className="col-md-4 pointer my-3" onClick={() => navigate("/app/accept")}>
              <div className="card-counter info">
                <i className="fa-solid fa-handshake"></i>
                <span className="count-numbers">Accept</span>
                <span className="count-name">My Admission</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Dashboard;
